import type { ComponentType } from "react";
import RejectionNotePdfComponent from "./RejectionNotePdf.jsx";

const RejectionNotePdf = RejectionNotePdfComponent as ComponentType<any>;
export default RejectionNotePdf;
